var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z","fill":"#F0F0F0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }